import React from 'react';
import { ExternalLink } from 'lucide-react';

interface InlineLinkProps {
  url: string;
  text: string;
  brandColor?: string;
}

export const InlineLink: React.FC<InlineLinkProps> = ({
  url,
  text,
  brandColor = "#060520"
}) => {
  return (
    <a 
      href={url} 
      target="_blank" 
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 font-medium hover:underline"
      style={{ color: brandColor }}
    >
      {text}
      <ExternalLink size={12} className="inline" />
    </a>
  );
}; 